"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.colors = void 0;

var _styles = require("@material-ui/core/styles");

var _responsiveFontSizes = _interopRequireDefault(require("./responsiveFontSizes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable implicit-arrow-linebreak */

/* eslint-disable object-curly-newline */
// https://app.zeplin.io/styleguide/5d1436f1e97c2156f49c0725/colors


var colors = {
  white: '#FFFFFF',
  dark: '#4A707C',
  gray: '#222222',
  minor: '#9B9B9B',
  darkText: '#DCDCDC',
  background: '#F7F8F8',
  yellow: '#FFCF71',
  green: '#44cdc6',
  red: '#D0021B',
  blue: '#4E6AF6',
  primary: '#222222',
  black: '#222222',
  secondary: '#44cdc6',
  mint: '#44cdc6',
  textSecondary: '#4A4A4A',
  active: '#5b9025',
  danger: '#D0021B',
  lightGrey: '#BCBCBC'
}; // https://material-ui.com/customization/default-theme/

exports.colors = colors;

var create = function create() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$pageWidth = _ref.pageWidth,
      pageWidth = _ref$pageWidth === void 0 ? 'md' : _ref$pageWidth,
      palette = _ref.palette,
      typography = _ref.typography,
      overrides = _ref.overrides;

  var theme = (0, _styles.createMuiTheme)({
    themeName: 'ArcBlock',
    palette: Object.assign({
      primary: {
        main: colors.blue,
        contrastText: colors.white
      },
      secondary: {
        main: colors.mint,
        contrastText: colors.white
      },
      danger: {
        main: colors.danger,
        contrastText: colors.white
      },
      text: {
        primary: '#404040',
        contrast: colors.white
      },
      background: {
        paper: mode === 'light' ? colors.white : colors.gray,
        "default": mode === 'light' ? colors.background : colors.gray
      },
      type: mode
    }, palette || {}),
    typography: Object.assign({
      useNextVariants: true,
      color: {
        main: mode === 'light' ? colors.gray : colors.white,
        gray: mode === 'light' ? colors.minor : colors.darkText,
        blue: colors.blue
      },
      fontSize: 16,
      fontFamily: ['Avenir', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',')
    }, typography || {}),
    overrides: Object.assign({
      MuiButton: {
        root: {
          borderRadius: 0,
          letterSpacing: '1.5px',
          boxShadow: 'none'
        }
      },
      MuiAppBar: {
        root: {
          height: 80
        }
      },
      MuiToolbar: {
        root: {
          background: mode === 'light' ? colors.background : colors.gray
        }
      },
      MuiTableCell: {
        root: {
          borderBottomWidth: '0',
          paddingTop: '14px',
          paddingBottom: '14px',
          paddingLeft: 0,
          paddingRight: '30px'
        },
        head: {
          textTransform: 'uppercase',
          color: mode === 'light' ? colors.gray : colors.darkText
        },
        body: {
          color: mode === 'light' ? colors.gray : colors.darkText
        }
      },
      MuiChip: {
        root: {
          padding: '3px',
          height: '24px',
          fontSize: '12px',
          marginRight: '10px'
        },
        label: {
          paddingLeft: '5px',
          paddingRight: '5px',
          marginRight: '5px'
        }
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '14px'
        }
      },
      MuiTypography: {
        body1: {
          color: mode === 'light' ? colors.gray : colors.darkText
        },
        body2: {
          color: mode === 'light' ? colors.gray : colors.darkText
        }
      }
    }, overrides || {}),
    pageWidth: pageWidth,
    colors: colors,
    mode: mode
  });
  var enhanced = (0, _responsiveFontSizes["default"])(theme, {
    breakpoints: ['xs', 'sm', 'md', 'lg'],
    disableAlign: false,
    factor: 3,
    variants: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']
  });
  return enhanced;
};

exports.create = create;